import moment from "moment";
import React from "react";
import {
	TORB3BackendRecord,
	TORB3Record,
} from "../../../../../redux/app/orb3/@types";
import { TORB3GroupC4_3 } from "../../../../../redux/app/orb3/groups/group-c";
import ORB3TableRows from "../ORB3TableRows";

type OwnProps = {
	orb3Record: TORB3Record | TORB3BackendRecord;
	theme?: "light" | "dark";
};
type ORB3GroupC4_3PreviewProps = OwnProps;

function ORB3GroupC4_3Preview(props: ORB3GroupC4_3PreviewProps) {
	const record = props.orb3Record as TORB3GroupC4_3;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY",
	);
	const { itemC4EntryExit, itemC4_3P1 } = record;

	function renderItemP1() {
		const { date: smtDate, time: smtTime } = itemC4_3P1;
		const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
		const utcTime = moment.utc(dateTimeLocal);
		return (
			<h4 className="font-medium uppercase">
				{utcTime.format("HH:mm")} hrs UTC on {utcTime.format("DD-MMM-YYYY")} (
				{smtTime} SMT on {moment(smtDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
			</h4>
		);
	}

	function renderMain() {
		return (
			<ORB3TableRows
				record={record}
				tableRows={[
					[operationDate, "3-C", "4", `SECA ${itemC4EntryExit.entryOrExit}`],
					[null, null, "-", renderItemP1()],
					[null, null, "NOTE", record.remarks],
				]}
				theme={props.theme}
			/>
		);
	}

	return renderMain();
}

export default ORB3GroupC4_3Preview;
